(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  $(document).ready(function() {
    var how_to = $('#how-to');
    var contents = $('#shopify-section-product-how-to').clone();
    how_to.append(contents.children());
    contents.remove();
  });

  (function() {
    if (!ElvenProductAddInfo) {
      return;
    }
    var elevenPrdDesc = document.getElementById('eleven-product-description');
    var elevenPrdTab = document.getElementById('eleven-product-accordion-tab');
    var elevenPrdTabUl = document.createElement('ul');

    elevenPrdDesc.innerHTML = ElvenProductAddInfo.productDescription && ElvenProductAddInfo.productDescription;
    new Array(10).fill(0).forEach(function(v, k) {
      var num = k + 1;
      if (ElvenProductAddInfo['productTabDisplay_'+num] === false) {
        return true;
      }
      var li = document.createElement('li');
      var html =  '<div class="subject">'+ElvenProductAddInfo['productTabSubject_'+num]+'</div>';
          html += '<div class="content">'+ElvenProductAddInfo['productTabContent_'+num]+'</div>';
      li.innerHTML = html;
      elevenPrdTabUl.appendChild(li);
    })
    if (elevenPrdTabUl.children.length > 0) {
      elevenPrdTab.appendChild(elevenPrdTabUl);
    }
    elevenPrdTabUl.addEventListener('click', function(e) {
      if (!e.target.classList.contains('subject')) {
        console.log(this)
        return;
      }
      var selected = e.target.parentNode.classList.contains('active');
      Array.prototype.forEach.call(elevenPrdTabUl.children, function(v) {
        v.classList.remove('active');
      })
      if (!selected) {
        e.target.parentNode.classList.add('active');
      }
    }, false);
  })();

  } catch(e) { console.error(e); }
})();

})();
